import React from 'react';
import { Job } from './components/Tabs/Job';
import { InspectionCalendar } from './components/Tabs/Calendar';
import moment from 'moment';

export const InspectionTabs = [
  {
    key: 'inspection-job',
    label: 'All Job',
    children: <Job />
  },
  {
    key: 'inspection-calendar',
    label: 'Onsite Job Calendar',
    children: <InspectionCalendar />
  }
];

export const convertDateToMoment = (range: [string, string]) => {
  if (range && Array.isArray(range)) {
    return range.map((date) => (moment.isMoment(date) ? date : moment(date)));
  }
  return undefined;
};
